module.exports = __webpack_public_path__ + "static/media/keynote.32c968b2.svg";